<template>
    <v-container fluid class="ma-0 pa-0">
        <v-row class="ma-0 pa-0" align="center">
            <v-btn text icon class="ml-0 mt-2" @click="refresh()">
                <v-icon>refresh</v-icon>
            </v-btn>

            <v-select v-model="type" :items="types" dense outlined hide-details class="ma-2" label="Tipo vista"
                style="max-width: 140px;" />

            <!-- Filtri admin -->
            <template v-if="amministratore">
                <v-select v-model="filtroStato" :items="elencoStati" item-text="descrizione" item-value="id" dense
                    outlined hide-details label="Stato" class="ma-2" style="max-width: 140px;">
                    <template v-slot:item="{ item }">
                        <v-list-item-content>
                            <v-list-item-title>{{ item.descrizione }}</v-list-item-title>
                        </v-list-item-content>
                    </template>
                </v-select>

                <v-select v-model="filtroTipologia" :items="elencoTipi" item-text="descrizione" item-value="id" dense
                    outlined hide-details clearable label="Tipologia" class="ma-2" style="max-width: 200px;"
                    single-line>
                    <template v-slot:selection="{ item }">
                        <v-icon small :color="item.colore || '#9E9E9E'" class="mr-1">circle</v-icon>
                        <span class="text-truncate">{{ item.descrizione }}</span>
                    </template>
                    <template v-slot:item="{ item }">
                        <v-list-item-icon class="mr-2">
                            <v-icon small :color="item.colore || '#9E9E9E'">circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ item.descrizione }}</v-list-item-title>
                        </v-list-item-content>
                    </template>
                </v-select>

            </template>

            <v-spacer />
            <v-btn small class="ma-2 mt-3" @click="setToday">Oggi</v-btn>
        </v-row>

        <v-row class="ma-0 pa-0" align="center" justify="space-between">
            <v-btn icon class="ma-2" @click="navigaPrecedente()">
                <v-icon large>arrow_left</v-icon>
            </v-btn>

            <span class="mt-2" style="text-align: center; font-weight: bold;">{{ meseCorrente }}</span>

            <v-btn icon class="ma-2" @click="navigaSuccessivo()">
                <v-icon large>arrow_right</v-icon>
            </v-btn>
        </v-row>

        <!-- Vista Calendario -->
        <v-sheet v-if="type !== 'list'" height="80vh">
            <v-calendar ref="calendar" v-model="today" :events="events" :event-color="getEventColor"
                :weekdays="[1, 2, 3, 4, 5]" @click:event="showEvent" @click:more="apriListaGiorno" locale="it-IT"
                color="primary" :now="today" @change="getEvents" :type="type">
                <template v-slot:event="{ event }">
                    <div :style="getEventStyle(event)" class="v-event-draggable v-event-timed"
                        style="width: 100%; height: 100%; padding-left: 4px; overflow: hidden;">
                        <strong>{{ event.name }}</strong>
                    </div>
                </template>
            </v-calendar>
        </v-sheet>

        <!-- Vista Lista -->
        <v-sheet v-else height="80vh" class="overflow-y-auto pa-4">
            <div v-if="eventiGiornalieriOrdinati.length === 0" class="text-center py-8">
                <v-icon size="64" color="grey lighten-1">event_busy</v-icon>
                <p class="text-h6 grey--text mt-4">Nessun evento in questo mese</p>
            </div>

            <div v-else>
                <div v-for="giorno in eventiGiornalieriOrdinati" :key="giorno.data" :data-giorno="giorno.data"
                    class="mb-6">
                    <v-card class="mb-2" elevation="1">
                        <v-card-title class="py-2 primary white--text">
                            <v-icon color="white" class="mr-2">event</v-icon>
                            {{ formatDataIntestazione(giorno.data) }}
                            <v-spacer></v-spacer>
                            <v-chip small color="white" class="primary--text">
                                {{ giorno.eventi.length }} {{ giorno.eventi.length === 1 ? 'evento' : 'eventi' }}
                            </v-chip>
                        </v-card-title>
                    </v-card>

                    <v-card v-for="(evento, index) in giorno.eventi" :key="index" class="mb-2" elevation="2"
                        @click="showEventFromList(evento)" style="cursor: pointer;" hover>
                        <v-card-text class="py-2">
                            <v-row align="center" no-gutters>
                                <v-col cols="auto">
                                    <div :style="{
                                        width: '4px',
                                        height: '100%',
                                        backgroundColor: evento.color,
                                        marginRight: '12px',
                                        borderRadius: '2px',
                                        minHeight: '40px'
                                    }"></div>
                                </v-col>

                                <v-col cols="auto" class="mr-4" style="min-width: 100px;">
                                    <div v-if="evento.tuttoIlGiorno" class="font-weight-bold">
                                        <v-icon small class="mr-1">schedule</v-icon>
                                        Tutto il giorno
                                    </div>
                                    <div v-else>
                                        <div class="font-weight-bold">{{ evento.oraInizio }}</div>
                                        <div class="text-caption grey--text">{{ evento.oraFine }}</div>
                                    </div>
                                </v-col>

                                <v-col>
                                    <div class="font-weight-medium">{{ evento.name }}</div>
                                    <div class="text-caption mt-1">
                                        <v-chip x-small outlined :color="evento.coloreStato || '#9E9E9E'">
                                            {{ evento.stato }}
                                        </v-chip>
                                    </div>
                                </v-col>

                                <v-col cols="auto">
                                    <v-icon color="grey">chevron_right</v-icon>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </div>
            </div>
        </v-sheet>

        <v-layout column transition="scale-transition" id="pulsantiAzione">
            <v-btn color="primary" dark top @click="apriDialog()">
                NUOVO
                <v-icon large>add</v-icon>
            </v-btn>
        </v-layout>

        <dettaglio-evento ref="dialogDettaglioEvento" @chiudi="chiudiDialog" :elencoTipi="elencoTipi"
            :elencoStati="elencoStati" :dialog="dialogNuovo" :evento="eventoSel" />

    </v-container>
</template>

<script>

import { get_tipo_eventi, get_eventi } from '@/api/api.dati';
import DettaglioEvento from './dialog/DettaglioEvento.vue';

export default {

    components: {
        DettaglioEvento
    },

    data: () => ({
        type: localStorage.getItem('calendario_tipo_vista') || 'month',
        types: [
            { text: 'Mese', value: 'month' },
            { text: 'Settimana', value: 'week' },
            { text: 'Lista', value: 'list' }
        ],
        weekday: [1, 2, 3, 4, 5],
        today: new Date().toISOString().substr(0, 10),

        events: [],
        listaEventi: [],

        elencoTipi: [],
        elencoStati: [],

        filtroTipologia: null,
        filtroStato: "",

        dialogNuovo: false,
        eventoSel: {},
    }),

    computed: {
        amministratore() {
            return this.$store.getters["user/getAmministratore"];
        },

        meseCorrente() {
            return new Date(this.today).toLocaleString("it", { month: "long" }).toUpperCase()
                + " " + new Date(this.today).getFullYear();
        },

        eventiGiornalieriOrdinati() {
            if (this.type !== 'list' || this.listaEventi.length === 0) return [];

            let eventiPerGiorno = {};
            let admin = this.amministratore;

            this.listaEventi.forEach(el => {
                const dataSolo = el.data.split('T')[0];
                if (!eventiPerGiorno[dataSolo]) eventiPerGiorno[dataSolo] = [];

                const oraInizio = el.oraInizio ? el.oraInizio.substring(0, 5) : '00:00';
                const oraFine = el.oraFine ? el.oraFine.substring(0, 5) : '23:59';
                const tuttoIlGiorno = (oraInizio === '00:00' && oraFine === '23:59');

                eventiPerGiorno[dataSolo].push({
                    name: admin ? (`${el.utente} - ${el.tipologia}`) : (el.stato == 1 ? el.tipologia : `${el.utente} - ${el.tipologia}`),
                    oraInizio,
                    oraFine,
                    color: el.coloreTipo || '#9E9E9E',
                    coloreStato: el.coloreStato || '#9E9E9E',
                    stato: el.stato,
                    raw: el,
                    tuttoIlGiorno
                });
            });

            return Object.keys(eventiPerGiorno).sort().map(data => ({
                data,
                eventi: eventiPerGiorno[data].sort((a, b) => {
                    if (a.tuttoIlGiorno && !b.tuttoIlGiorno) return -1;
                    if (!a.tuttoIlGiorno && b.tuttoIlGiorno) return 1;
                    return a.oraInizio.localeCompare(b.oraInizio);
                })
            }));
        }
    },

    watch: {
        // Ricarica eventi al cambio filtro (solo admin)
        filtroTipologia() { this.refresh(); },
        filtroStato() { this.refresh(); },

        type(val) {
            localStorage.setItem('calendario_tipo_vista', val);
        },
    },

    mounted() {
        this.getTipiDati();
        if (this.type === 'list') {
            this.refresh();
        }
        /* 
        Eventi
        Visita medica 
        
        Azienda Battisti come utente prima di tutti
        
        */
    },

    methods: {
        async refresh() {
            await this.getTipiDati();
            let start = new Date(this.today);
            start.setDate(1);
            let end = new Date(this.today);
            end.setMonth(end.getMonth() + 1);
            end.setDate(0);
            await this.getEvents({}, start.toISOString().split('T')[0], end.toISOString().split('T')[0]);
        },

        async getTipiDati() {
            let res = await get_tipo_eventi("Tipo");
            this.elencoTipi = res.data;
            res = await get_tipo_eventi("Stato");
            this.elencoStati = res.data;
        },

        async getEvents({ start, end } = {}, iso_start, iso_end) {
            let par = {
                dataInizio: start == undefined ? iso_start : start.date,
                dataFine: end == undefined ? iso_end : end.date,
                // Inviati solo se admin (ignorati lato backend per gli altri)
                idTipologia: this.filtroTipologia || null,
                idStato: this.filtroStato || null,
            };
            let res = await get_eventi(par);
            this.listaEventi = res.data;
            this.caricaEventiInCalendario();
        },

        caricaEventiInCalendario() {
            let admin = this.amministratore;
            this.events = this.listaEventi.map(el => {
                const dataSolo = el.data.split('T')[0];
                let dettaglio = `${el.oraInizio.substring(0, 5)}-${el.oraFine.substring(0, 5)} ${el.utente} - ${el.tipologia}`
                return {
                    name: admin ? (dettaglio) : (el.stato == 1 ? el.tipologia : dettaglio),
                    start: `${dataSolo} ${el.oraInizio.substring(0, 5)}`,
                    end: `${dataSolo} ${el.oraFine.substring(0, 5)}`,
                    color: el.coloreTipo || '#9E9E9E',
                    timed: true,
                    raw: el,
                    isDraft: el.idStato === "1" || el.idStato === 1,
                    isRifiutato: el.idStato === "3" || el.idStato === 3,
                };
            });
        },

        getEventStyle(event) {
            const color = event.color;
            if (event.isDraft) {
                return {
                    backgroundColor: 'white',
                    color: 'black',
                    border: `2px solid ${color}`,
                    borderRadius: '4px',
                    height: '100%'
                };
            }
            if (event.isRifiutato) {
                return {
                    backgroundColor: 'white',
                    color: '#b71c1c',
                    border: `2px dashed #b71c1c`,
                    borderRadius: '4px',
                    height: '100%'
                };
            }
            return {
                backgroundColor: color,
                color: 'white',
                borderRadius: '4px',
                height: '100%'
            };
        },

        getEventColor(event) {
            return event.color;
        },

        setToday() {
            this.today = new Date().toISOString().substr(0, 10);
            if (this.type === 'list') this.refresh();
        },

        showEvent({ event }) {
            this.eventoSel = event.raw;
            this.dialogNuovo = true;
        },

        showEventFromList(evento) {
            this.eventoSel = evento.raw;
            this.dialogNuovo = true;
        },

        apriDialog() {
            this.eventoSel = { data: this.today, idStato: "1", descrizione: "", ore: 0, minuti: 0, oraFine: "", oraInizio: "", stato: "", tipologia: "", utente: "", idUtente: -1 };
            this.dialogNuovo = true;
        },

        chiudiDialog(aggiorna) {
            this.dialogNuovo = false;
            if (aggiorna) this.refresh();
        },

        navigaPrecedente() {
            if (this.type === 'list') {
                let data = new Date(this.today);
                data.setMonth(data.getMonth() - 1);
                this.today = data.toISOString().substr(0, 10);
                this.refresh();
            } else {
                this.$refs.calendar.prev();
            }
        },

        navigaSuccessivo() {
            if (this.type === 'list') {
                let data = new Date(this.today);
                data.setMonth(data.getMonth() + 1);
                this.today = data.toISOString().substr(0, 10);
                this.refresh();
            } else {
                this.$refs.calendar.next();
            }
        },

        formatDataIntestazione(data) {
            const date = new Date(data + 'T00:00:00');
            const giornoSettimana = date.toLocaleDateString('it-IT', { weekday: 'long' });
            const giorno = date.getDate();
            const mese = date.toLocaleDateString('it-IT', { month: 'long' });
            const anno = date.getFullYear();
            return `${giornoSettimana.charAt(0).toUpperCase() + giornoSettimana.slice(1)}, ${giorno} ${mese} ${anno}`;
        },

        apriListaGiorno({ date }) {
            this.today = date;
            this.type = 'list';
            this.$nextTick(() => {
                const el = document.querySelector(`[data-giorno="${date}"]`);
                if (el) el.scrollIntoView({ behavior: 'smooth' });
            });
        },
    }
}
</script>

<style scoped>
.overflow-y-auto {
    overflow-y: auto;
}

/* aggiungere nello <style scoped> */
.v-event-more {
    cursor: pointer;
}

.v-event-more::before {
    content: "+ altri ";
}

/* nasconde il testo originale "+X more" e mostra solo il numero */
.v-event-more {
    font-size: 0;
    /* nasconde "+X more" */
    color: transparent;
}

.v-event-more::before {
    font-size: 12px;
    /* riporta il testo visibile */
    color: var(--v-primary-base);
}
</style>